import React from "react";
import styles from "./ActiveLabel.module.scss";

type Props = {
  isActive: boolean;
};

export const ActiveLabel: React.FC<Props> = ({ isActive }) => {
  return (
    <div className={`badge ${isActive ? "badge--success" : "badge--danger"}`}>
      {isActive ? "On" : "Off"}
    </div>
  );
};
